// share mediums
export const EMAIL = 'email';
export const GOOGLE = 'google';
export const SLACK = 'slack';
export const FACEBOOK = 'facebook';
export const TWITTER = 'twitter';
export const COPIED_LINK = 'copied_link';

export const INVITE_MEDIUMS = [
  EMAIL,
  SLACK,
  FACEBOOK,
  GOOGLE,
  TWITTER,
  COPIED_LINK,
];

// share data keys
export const EXTERNAL_CONVERSATION_TYPE = 'external_conversation_type';
export const EXTERNAL_CONVERSATION_ID = 'external_conversation_id';
export const MESSAGE = 'message';

export const INVITE_TEAM_VIEW_THRESHOLD = 3;

// generic invite states, feel free to use and adapt
export const INVITE_STATUS_CREATED = 'created';
export const INVITE_STATUS_SENT = 'sent';
export const INVITE_STATUS_FAILED = 'failed';
export const INVITE_STATUS_ACCEPTED = 'accepted';
export const INVITE_STATUS_DELETED = 'deleted';
